import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaLocationDot, FaEnvelope, FaPhone, FaXTwitter, FaYoutube } from "react-icons/fa6";
import PDFViewer from "./PDFViewer";

const Footer = () => {
  const [pdfViewer, setPdfViewer] = useState({
    isOpen: false,
    url: '',
    title: ''
  });

  const openPDF = (url, title) => {
    setPdfViewer({
      isOpen: true,
      url,
      title
    });
  };

  const closePDF = () => {
    setPdfViewer({
      isOpen: false,
      url: '',
      title: ''
    });
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-gray-300 relative overflow-hidden font-inter">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='https://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      {/* Main Footer Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-4 mb-4">
              <div className="relative">
                <img
                  src="/mylogo.png"
                  alt="KNKSS Logo"
                  className="w-16 h-16 rounded-full object-contain border-2 border-blue-400 shadow-lg hover:shadow-blue-400/25 transition-all duration-300"
                />
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
              </div>
              <div>
                <h1 className="text-2xl lg:text-3xl font-bold text-white tracking-tight">KNKSS</h1>
                <p className="text-sm text-blue-300 font-medium">Kabir Nagar Khel Samiti</p>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed mb-3 text-sm">
              Empowering cricket enthusiasts through knowledge, community, and sportsmanship at Kabir Nagar. Building champions, fostering unity.
            </p>
            
            {/* Social Media */}
            <div className="flex space-x-3 mt-3 mb-0">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg"
                aria-label="Facebook"
              >
                <FaFacebookF className="text-sm" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-gray-800 hover:bg-pink-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg"
                aria-label="Instagram"
              >
                <FaInstagram className="text-sm" />
              </a>
              <a 
                href="https://x.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-gray-800 hover:bg-black rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg"
                aria-label="X"
              >
                <FaXTwitter className="text-sm" />
              </a>
              <a 
                href="https://youtube.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-gray-800 hover:bg-red-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg"
                aria-label="YouTube"
              >
                <FaYoutube className="text-sm" />
              </a>
            </div>




          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-3 relative inline-block">
              Quick Links
              <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full"></div>
            </h3>
            <div className="grid grid-cols-2 gap-x-4 gap-y-1">
              <ul className="space-y-2">
                <li>
                  <Link 
                    to="/" 
                    className="text-gray-300 hover:text-white transition-all duration-200 flex items-center group text-sm font-medium"
                  >
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:scale-125"></span>
                    Home
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/about" 
                    className="text-gray-300 hover:text-white transition-all duration-200 flex items-center group text-sm font-medium"
                  >
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:scale-125"></span>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/events" 
                    className="text-gray-300 hover:text-white transition-all duration-200 flex items-center group text-sm font-medium"
                  >
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:scale-125"></span>
                    Events
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/gallery" 
                    className="text-gray-300 hover:text-white transition-all duration-200 flex items-center group text-sm font-medium"
                  >
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:scale-125"></span>
                    Gallery
                  </Link>
                </li>
                <li>
                  <a 
                    href="https://superplayerauction.com/auctions.php?actid=54532" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-white transition-all duration-200 flex items-center group text-sm font-medium"
                  >
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:scale-125"></span>
                    Auction
                  </a>
                </li>
              </ul>

              <ul className="space-y-2">
                <li>
                  <Link 
                    to="/members" 
                    className="text-gray-300 hover:text-white transition-all duration-200 flex items-center group text-sm font-medium"
                  >
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:scale-125"></span>
                    Members
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/rules" 
                    className="text-gray-300 hover:text-white transition-all duration-200 flex items-center group text-sm font-medium"
                  >
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:scale-125"></span>
                    Rules
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/register" 
                    className="text-gray-300 hover:text-white transition-all duration-200 flex items-center group text-sm font-medium"
                  >
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:scale-125"></span>
                    Register
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/admin" 
                    className="text-gray-300 hover:text-blue-400 transition-all duration-200 flex items-center group text-sm font-medium"
                  >
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:scale-125"></span>
                    Admin
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-3 relative inline-block">
              Contact Us
              <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full"></div>
            </h3>
            <div className="space-y-2">
              <div className="flex items-start space-x-3 group">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-blue-500 transition-colors duration-200">
                  <FaLocationDot className="text-white text-xs" />
                </div>
                <div>
                  <p className="text-gray-300 text-sm leading-relaxed group-hover:text-white transition-colors duration-200">
                    118- Ward No.2,Kabir Nagar,<br />
                    Raipur, Chhattisgarh - 492001
                  </p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3 group">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-blue-500 transition-colors duration-200">
                  <FaEnvelope className="text-white text-xs" />
                </div>
                                <a 
                  href="mailto:knkskabirnagarraipur@gmail.com"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium"
                >
                  knkskabirnagarraipur@gmail.com
                </a>
              </div>
            </div>
          </div>


        </div>
        
        {/* Policy Links */}
        <div className="flex justify-end gap-4 mt-2 mb-1">
          <div 
            onClick={() => openPDF('/T&C/privacyPolicy.pdf', 'KNKSS Privacy Policy')}
            className="inline-block text-gray-300 hover:text-white transition-all duration-200 text-xs font-medium cursor-pointer"
          >
            Privacy Policy
          </div>
          <div 
            onClick={() => openPDF('/T&C/termsconditionpolicy.pdf', 'KNKSS Terms & Conditions')}
            className="inline-block text-gray-300 hover:text-white transition-all duration-200 text-xs font-medium cursor-pointer"
          >
            Terms & Conditions
          </div>
          <div 
            onClick={() => openPDF('/T&C/refundpolicy.pdf', 'KNKSS Refund Policy')}
            className="inline-block text-gray-300 hover:text-white transition-all duration-200 text-xs font-medium cursor-pointer"
          >
            Refund Policy
          </div>
        </div>
        
        {/* Copyright Section */}
        <div className="mt-8 pt-6 relative">
          {/* Animated Border Line */}
          <div className="relative h-px bg-gradient-to-r from-transparent via-gray-400 to-transparent overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-400 to-transparent animate-pulse"></div>
            <div className="absolute left-1/2 transform -translate-x-1/2 w-8 h-8 bg-slate-900 rounded-full border-2 border-gray-400 flex items-center justify-center animate-glowPulse">
              <div className="w-2 h-2 bg-blue-400 rounded-full animate-ping"></div>
              <div className="absolute inset-0 rounded-full bg-blue-400/20 animate-centerPulse"></div>
            </div>
            {/* Expanding Lines from Center */}
            <div className="absolute left-1/2 w-0 h-px bg-gradient-to-r from-blue-400 to-transparent animate-expandFromCenter origin-left"></div>
            <div className="absolute right-1/2 w-0 h-px bg-gradient-to-l from-blue-400 to-transparent animate-expandFromCenter origin-right"></div>
          </div>
          <div className="flex justify-center mt-6">
            <p className="text-sm text-gray-400 text-center">
              © {new Date().getFullYear()} KNKSS (Kabir Nagar Khel Samiti Society). All rights reserved.
            </p>
          </div>
          <div className="flex justify-center items-center mt-2 space-x-4">
            <p className="text-xs text-gray-400">
              All content, logos, and trademarks are property of KNKSS (Kabir Nagar Khel Samiti Society) and are protected by copyright law.
              Powered by{' '}
              <a
                href="https://techidea.co.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-300 hover:text-blue-200 underline"
              >
                Tech idea
              </a>
            </p>
          </div>
        </div>
      </div>
      
      {/* PDF Viewer Modal */}
      <PDFViewer
        isOpen={pdfViewer.isOpen}
        onClose={closePDF}
        pdfUrl={pdfViewer.url}
        title={pdfViewer.title}
      />
    </footer>
  );
};

export default Footer;
